import { useHistory } from 'react-router-dom';
import 'styles/pages/SelectPaymentTypePage.scss';

const payments = [
  {
    name: 'First Data',
    icon: '/images/fiserv-logo.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    redirect: '/private/admin/payments/first-data',
  },
  {
    name: 'Izipay',
    icon: '/images/izipay-logo.png',
    borderColor: '#FF4240',
    bg: '#FF4240',
    redirect: '/private/admin/payments/izipay',
  },
  {
    name: 'Mercado Pago',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago',
  },
  {
    name: 'Mercado Pago Checkout',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago-checkout',
  },
  {
    name: 'Mercado Pago Checkout Point',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago-point',
  },
  {
    name: 'Clover Point',
    icon: '/images/clover-logo.png',
    borderColor: '#E6E6E6',
    bg: '#E6E6E610',
    redirect: '/private/admin/payments/clover-point',
  },
  {
    name: 'Fiserv QR',
    icon: '/images/white-qr.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    opacity: '',
    redirect: '/private/admin/payments/fiserv-qr',
  },
  {
    name: 'Sitef',
    icon: '/images/sitef-logo.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    redirect: '/private/admin/payments/sitef',
  },
];

export default (): JSX.Element => {
  const history = useHistory();
  return (
    <>
      <div className="payment-container-grid">
        {payments.map((payment, i) => {
          return (
            <article
              key={i}
              onClick={() => history.push(payment.redirect)}
              className="card"
              style={{
                borderColor: payment.borderColor,
                backgroundColor: payment.bg,
              }}
            >
              <div className="ctn">
                <img src={payment.icon ?? ''} alt={payment.name} />
                <p>{payment.name}</p>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};
